import React from 'react';
import Form from './Form';
import "./App.css"
function App() {
  return (
    <div className="App">
      <Form />
    </div>
  );
}

export default App;
